import type { ObjectActionHandlers } from "@/object-actions/types";
import { useMemo } from "react";

export interface MultiSelectionHandlerDeps {
  onOpen: () => void;
  onRename: () => void;
  onBulkMove: () => void;
  onDuplicate: () => void;
  onShare: () => void;
  onBulkDelete: () => void;
  canOpen: boolean;
  canRename: boolean;
  canMove: boolean;
  canDuplicate: boolean;
  canShare: boolean;
  canDelete: boolean;
}

export function createMultiSelectionActionHandlers(
  deps: MultiSelectionHandlerDeps,
): ObjectActionHandlers {
  return {
    open: deps.canOpen ? () => deps.onOpen() : undefined,
    rename: deps.canRename ? () => deps.onRename() : undefined,
    "bulk-move": deps.canMove
      ? () => window.setTimeout(() => deps.onBulkMove(), 0)
      : undefined,
    duplicate: deps.canDuplicate ? () => deps.onDuplicate() : undefined,
    share: deps.canShare ? () => deps.onShare() : undefined,
    "bulk-delete": deps.canDelete
      ? () => window.setTimeout(() => deps.onBulkDelete(), 0)
      : undefined,
  };
}

export function useMultiSelectionObjectActionHandlers(
  deps: MultiSelectionHandlerDeps,
): ObjectActionHandlers {
  return useMemo(() => createMultiSelectionActionHandlers(deps), [deps]);
}
